import {useQaAccuracy, useQaVerticalAccuracy} from '@/api/hooks';
import {
  type AccuracyOutcome,
  ReviewAccuracySummary
} from '@/components/shared/ReviewAccuracySummary';

const OUTCOMES: AccuracyOutcome[] = [
  {field: 'true_positive', label: 'True positive'},
  {field: 'false_positive', label: 'False positive', error: true}
];

export function QaAccuracySummary() {
  return (
    <ReviewAccuracySummary
      showTrend
      idPrefix="qa-accuracy"
      outcomes={OUTCOMES}
      useVerticalRows={useQaVerticalAccuracy}
      useAnalystRows={useQaAccuracy}
      defaultPreset="Last 3 months"
    />
  );
}
